/**
 * RemoveButton — disabled-in-RO scaffolded `×` button. VQE-Edit flips
 * `disabled={false}` per § 1.4 hand-off contract. Disabled-state copy via a
 * shadcn `VqeTooltip` with `selfProvider`, so the component is renderable
 * outside the app-root `<TooltipProvider>`.
 */

import { X } from 'lucide-react';

import { cn } from '../../../../../lib/utils';
import { Button } from '../../../../../components/ui/button';
import { vqeCopy } from '../../ux/vqeCopy';
import { VqeTooltip } from './VqeTooltip';

export interface RemoveButtonProps {
  readonly testId: string;
  readonly ariaLabel?: string;
  readonly disabled?: boolean;
  readonly tooltip?: string;
  readonly onClick?: () => void;
  /** Extra classes applied to the inner button element (e.g. hover treatments). */
  readonly className?: string;
}

const DEFAULT_TOOLTIP = vqeCopy.disabled.editingUnavailable;

export function RemoveButton({
  testId,
  ariaLabel = 'Remove',
  disabled = true,
  tooltip = DEFAULT_TOOLTIP,
  onClick,
  className,
}: RemoveButtonProps) {
  return (
    <VqeTooltip content={disabled ? tooltip : undefined} selfProvider>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn('h-5 w-5 p-0 text-muted-foreground', className)}
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        data-testid={testId}
        aria-disabled={disabled}
        aria-label={ariaLabel}
      >
        <X className="h-3 w-3" />
      </Button>
    </VqeTooltip>
  );
}
